import { createRequiredContext } from '../createRequiredContext';
const { useContext, Provider, Context, Consumer } = createRequiredContext('EssentialsProvider');
export const EssentialsProvider = Provider;
export const EssentialsConsumer = Consumer;
export const EssentialsContext = Context;
export const useEssentials = useContext;
//# sourceMappingURL=EssentialsProvider.js.map